import to from 'await-to-js';
import { FetchInit } from 'enterprise-fetch';

import { enhancedFetch } from './Fetch';
import { tryParse } from './Parse';

class HttpProvider {
  static async get<T = unknown, U = Error>(url: string, init: FetchInit = {}) {
    return this.fetch<T, U>(url, { method: 'GET', ...init });
  }

  static async fetch<T = unknown, U = Error>(
    uri: string,
    init: FetchInit = {}
  ): Promise<[U | Error | null, T | undefined, Response | undefined]> {
    const [error, response] = await to(enhancedFetch(uri, init));

    if (response && !error) {
      const [bodyError, text] = await to(response.text());

      if (bodyError) return [bodyError, undefined, response];

      const parsed = tryParse<T | U>(text);
      if (parsed) {
        const err =
          !response.status || !response.ok
            ? new Error(`${response.status} ${response.statusText}`, {
                cause: parsed,
              })
            : null;

        const payload =
          response.status && response.ok ? (parsed as T) : undefined;
        return [err, payload, response];
      }

      return [
        response.ok
          ? null
          : new Error(`${response.status} ${response.statusText}`, {
              cause: text,
            }),
        response.ok ? (text as T) : undefined,
        response,
      ];
    }
    return [error, undefined, response];
  }
}

export default HttpProvider;
